<script setup>
import {reactive, onMounted, computed, ref, onUpdated, watch} from 'vue';
import {DateTime} from "luxon";
import Button from "@common/Elements/Button";

const props = defineProps({
  entity: {
    required: true,
  },
  selected: {
    default: {}
  },
  dates: {
    type: Array,
    default : ()=>[],
  },
})

const data = ref({});

onMounted(() => {
  data.value = props.selected
  data.value.start_date = data.value.start_date ? DateTime.fromISO(data.value.start_date).toFormat('yyyy-MM-dd') : null;
  data.value.end_date = data.value.end_date ? DateTime.fromISO(data.value.end_date).toFormat('yyyy-MM-dd') : null;
})

watch(props.selected, () => {
  data.value.start_date = data.value.start_date ? DateTime.fromISO(data.value.start_date).toFormat('yyyy-MM-dd') : null;
  data.value.end_date = data.value.end_date ? DateTime.fromISO(data.value.end_date).toFormat('yyyy-MM-dd') : null;
})

const emits = defineEmits([
  'error',
  'changed',
  'saved',
])

const changed = () => {
  validateDates();
}

const validateDates = () => {
  emits('error', {message: null})

  if (data.value.start_date) {
    let today = new Date;
    today.setUTCHours(0, 0, 0, 0);
    let start = new Date(data.value.start_date)
    if (start - today < 24 * 60 * 60 * 1000) {
      emits('error', {message: 'Start date must be in the future.'})
      return false
    }
  }


  if (data.value.start_date && data.value.end_date) {
    if (DateTime.fromISO(data.value.end_date).diff(DateTime.fromISO(data.value.start_date), 'days').days < 0) {
      emits('error', {message: 'End date must be after start date.'})
      return false
    }

  }

  let periods = props.dates.filter((period) => period.dates.id != props.selected.id)

  periods.forEach((period) => {
    let periodEnd = period.dates.end;
    let periodStart = period.dates.start;
    let start = new Date(data.value.start_date);
    let end = new Date(data.value.end_date);
    periodEnd.setUTCHours(0,0,0,0);
    periodStart.setUTCHours(0,0,0,0);
    start.setUTCHours(0,0,0,0);
    end.setUTCHours(0,0,0,0);
    periodEnd = periodEnd.valueOf();
    periodStart = periodStart.valueOf();
    start = start.valueOf();
    end = end.valueOf();

    if(periodStart <  end && periodEnd > start ){
      emits('error', {message: 'The selected period overlaps with another period'})
      return false
    }
  })

  return true
}

const save = () => {
  if (validateDates()) {
    if (!data.value.start_date || !data.value.price) {
      emits('error', {message: 'All fields are required.'})
    } else {
      emits('error', {message: null})
      axios.post(
        route('api.products.prices.store', {
          id: props.entity.id,
        }),
        data.value)
        .then((response) => {
          emits('saved', response.data.data)
        })
        .catch((error) => {
          emits('error', {message: error.response.data.message})
        })
    }
  }
}

const deleteUpsellPrice = () => {
  axios
    .delete(
      route('api.products.prices.delete', props.selected.id))
    .then((response) => {
      emits('saved', response.data.data)
    })
    .catch((error) => {
      emits('error', {message: error.response.data.message})
    })

}

const updateUpsellPrice = () => {
  if (validateDates()) {
    if (!data.value.start_date || !data.value.price) {
      emits('error', {message: 'All fields are required.'})
    } else {
      emits('error', {message: null})
      axios
        .put(
          route('api.products.prices.update',
            {
              id: props.entity.id,
              price_id: data.value.id,
            }),
          data.value
        )
        .then((response) => {
          emits('saved', response.data.data)
        })
        .catch((error) => {
          emits('error', {message: error.response.data.message})
        })
    }
  }
}

</script>

<template>
  <div class=" mt-2 ml-6">
    <div class="grid gap-4 grid-cols-2">
      <div>
        Start
        <input type="date"
               id="start"
               @change="changed"
               v-model="data.start_date"
               class="w-full h-10 rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        />
      </div>
      <div>
        Eind
        <input type="date"
               id="end"
               @change="changed"
               v-model="data.end_date"
               class="w-full h-10 rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        />
      </div>
      <div class="col-span-2">
        <div class="grid grid-cols-2 gap-4">
          <div class="col-span-1">
            Upsell Prijs
            <input
              type="text"
              v-model="data.price"
              class="block h-10 w-full rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

        </div>
      </div>
      <div class="col-span-2 flex content-end mt-2">
        <button
          v-if="!selected.id"
          type="button"
          class="inline-block bg-slate-500 hover:bg-slate-700 cursor-pointer rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm"
          @click="save">
          Prijs opslaan
        </button>
        <button
          v-if="selected.id"
          type="button"
          class="inline-block border text-slate-500 border-slate-500 hover:bg-slate-700 cursor-pointer rounded-md px-4 py-2 text-sm font-medium hover:text-white shadow-sm"
          @click="deleteUpsellPrice">
          Prijs verwijderen
        </button>
        <button
          v-if="selected.id"
          type="button"
          class="ml-4 inline-block bg-slate-500 hover:bg-slate-700 cursor-pointer rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm"
          @click="updateUpsellPrice">
          Prijs aanpassen
        </button>
      </div>

    </div>


    <div>

    </div>
  </div>
</template>
